import request from '@/utils/request'
export function getArticles(query) {
    return request({
        url: "/article/list",
        method: 'get',
        params: query
    })
}
export function getSearchArticle(query) {
    return request({
        url: "/article/search",
        method: 'get',
        params: query
    })
}
export function submitOrder(data) {
    return request({
        url: "/common/technicalService",
        method: "post",
        data: data
    })
}